import SterilizationInfoPanel from 'src/components/material/DeviceDashboard/SterilizationInfo/SterilizationInfoPanel';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentPressureUnit, fetchCycleEvents } from '../summaryDashboardSlice';

const SterilizationInfoContainer = () => {
    const dispatch = useDispatch();
    const {
        cycleEvents,
        cycleMetadata,
        selectedCycle,
        currentPressureUnit,
        deviceSerial,
        userTimezone,
        deviceTimezone,
        weightUnit,
    } = useSelector(
        // @ts-ignore
        (store) => store.summarydashboard
    );

    // @ts-ignore
    const loading = useSelector((store) => store.summarydashboard.loading.sterilizationInfo);

    const setPressureUnit = (pressureUnit) => {
        dispatch(setCurrentPressureUnit(pressureUnit));
    }

    const fetchEvents = () => {
        // @ts-ignore
        dispatch(fetchCycleEvents(selectedCycle.id));
    }

    return (
        <SterilizationInfoPanel
            cycleEvents={cycleEvents}
            cycleMetadata={cycleMetadata}
            selectedCycle={selectedCycle}
            currentPressureUnit={currentPressureUnit}
            deviceSerial={deviceSerial}
            userTimezone={userTimezone}
            deviceTimezone={deviceTimezone}
            weightUnit={weightUnit}
            loading={loading}
            setPressureUnit={setPressureUnit}
            fetchCycleEvents={fetchEvents}
        />
    )
}

export default SterilizationInfoContainer
